import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoBaixaLicenciamentoConfig = {
  id: 'pedido_baixa_licenciamento',
  nome: 'Pedido de Baixa de Licenciamento',
  categoria: 'inscricao',
  descricao: 'Solicitação de baixa de licenciamento na OAB/MS',
  icon: 'FaFileAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento de Licenciamento preenchido e assinado digitalmente', 
        required: true 
      },
       { 
        id: 'Exoneracao', tipoDocumentoProcesso: 525, 
        name: 'Exoneração', 
        description: 'Documento indispensável para comprovar o motivo da baixa do licenciamento.', 
        required: true 
      }
    ],
  },

  paymentConfig: {
    amount: 152.00
  },

  protocoloConfig: {
    modeloRequerimento: '202',
    tiposAssunto: '267',
    tipoPedido: '254'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 106,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoBaixaLicenciamentoConfig;